(function() {
	$.fn.extend({
		uniqueBy: function(uniquenessKey) {
			var unique = [];

			return $(this).filter(function(index, elem) {
				var key = uniquenessKey(this);
				if (unique.indexOf(key) == -1) {
					unique.push(key);
					return true;
				}
				return false;
			});
		},

		updateSelect: function() {
			var $multiselect = $('.ui-multiselect');
			var $multiple = $(this)
				.filter($multiselect.prev());
			$multiple.multiselect('refresh');

			var $chosen = $('.chzn-container');
			var $single = $(this)
				.filter($chosen.prev());
			$single.trigger('liszt:updated');
		},

		/**
		* Determines whether the given element has a horizontal scrollbar.
		* @see Visit http://stackoverflow.com/a/4814526/684271 to see the inspiration for this plugin.
		*/
		hasHorizontalScrollbar: function() {
			return this.get(0).scrollWidth > this.width();
		}
	});
})();